import { createSelector } from "@reduxjs/toolkit";

// Base selectors
const selectFilterState = (state) => state.filter;

// Memoized selectors
export const makeSelectSelectedFilterFields = (module) =>
  createSelector(
    [selectFilterState],
    (filterState) => filterState.selectedFilterFields[module] || []
  );

export const makeSelectFilters = (module) =>
  createSelector(
    [selectFilterState],
    (filterState) => filterState.filters[module] || []
  );

// Usage inside the component
// const selectedFilterFields = useSelector(makeSelectSelectedFilterFields(module));
// const filters = useSelector(makeSelectFilters(module));
